<template lang="pug">
  multiselect(
    ref="multiselect"
    v-model="accommodationType"
    :options="accommodationTypes"
    label="label"
    track-by="value"
    :searchable="false"
    :show-labels="false"
    :allow-empty="false"
    placeholder="Types de biens"
  )
    template(slot="beforeList")
      div(class="p-5" @click="handleReset") Quel type de bien ?

    template(slot="singleLabel" v-if="$mq === 'mobile'")
      span(class="align-middle leading-10") Types de biens
</template>

<script>
export default {
  props: {
    initialAccommodationType: {
      type: String,
      default: null
    },

    accommodationTypes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      accommodationType: null
    }
  },

  watch: {
    accommodationType () {
      if (this.accommodationType) {
        this.$store.commit('updateParams', { key: 'by_accommodation_type', value: this.accommodationType.value })

        this.$store.dispatch('searchAccommodations')
      }
    }
  },

  mounted () {
    this.accommodationType = this.accommodationTypes.find(accommodationType => accommodationType.value === this.initialAccommodationType)

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'typeSelect')
    })
  },

  methods: {
    handleReset () {
      if (this.accommodationType) {
        this.accommodationType = null

        this.$store.commit('deleteParams', 'by_accommodation_type')

        this.$store.dispatch('searchAccommodations')
      }

      this.$refs.multiselect.$el.blur()
    }
  }
}
</script>
